import { render, staticRenderFns } from "./AudioSettingTab.vue?vue&type=template&id=211b2b4f&scoped=true&"
import script from "./AudioSettingTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AudioSettingTab.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AudioSettingTab.vue?vue&type=style&index=0&id=211b2b4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211b2b4f",
  null
  
)

export default component.exports